import React from "react";
import { Typography } from "@/components/Typography";

interface ImagesHeaderProps {
  albumTitle?: string;
  albumDescription?: string;
}

export const ImagesHeader = ({ albumTitle, albumDescription }: ImagesHeaderProps) => {
  return (
    <>
      {albumTitle && (
        <div className="images-preview__album-name">
          <Typography
            Tag="p"
            size="l"
            classname="u-bold u-spacing-4"
          >
            {albumTitle}
          </Typography>
        </div>
      )}

      {albumDescription && (
        <div className="images-preview__album-description">
          <Typography
            Tag="p"
            size="s"
          >
            {albumDescription}
          </Typography>
        </div>
      )}
    </>
  );
};
